<template>
  <AttrGroup title="表盘整体缩放">
    <AttrInputNumber
      class="mt-2.5"
      :value="editorStore.themeScale * 100"
      label="缩放"
      addon-after="%"
      :max="scaleMaxMin.max * 100"
      :min="scaleMaxMin.min * 100"
      :precision="0"
      :tooltip="`可在${scaleMaxMin.min * 100}%-${
        scaleMaxMin.max * 100
      }%之间调整，缩放值超过100%时，图片会模糊，请注意！`"
      @change="onGlobalScaleChange"
    />
  </AttrGroup>
</template>

<script setup lang="ts">
import { useShapeTransform } from '@/hooks';
import { useEditorStore } from '@/store/use-editor-store';
import { emitter, EventType } from '@/utils/emitter.utils';

const editorStore = useEditorStore();
const { scaleMaxMin } = useShapeTransform();

// 仅针对图片、图组生效的全局缩放；只更新 theme.scale，AST 中仅对 Image/ImageArray 应用该缩放
const onGlobalScaleChange = (v: number) => {
  const scale = v / 100;

  // editorStore.theme && (editorStore.theme!.scale = scale);
  // flatShapeTree.value
  //   .filter(
  //     (node) =>
  //       node.extra.tag == ShapeType.Image ||
  //       node.extra.tag == ShapeType.ImageArray
  //   )
  //   .forEach(async (n) => {
  //     const shape = Shape.getShape(n.key);
  //     // console.log("🚀 ~ shape:", shape?.isPointerImage, shape)
  //     // 没有单独设置缩放并且不是指针图片才设置缩放
  //     shape && !shape.attrs.isSetSingleScale && !shape?.isPointerImage && (await setScale(shape, scale));
  //   });

  if (editorStore.theme) editorStore.theme.scale = scale;
  emitter.emit(EventType['theme:set-attr']);
};
</script>

<style scoped></style>
